// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { boolean } from "@altostra/type-validations/lib/primitives";

export const isCloudStorageCapabilityResult = objectOf({
  can_export_to_cloud_data_storage: boolean,
});
